<template>
  <li class="q-list-group-item q-list-group-item q-d-flex q-justify-content-between q-align-items-start q-px-0 q-p-1 q-text-start">
    <a class="q-text-decoration-none q-link-secondary single-suggestion__link"
       :class="{'q-btn q-btn-danger q-rounded-3 q-shadow-sm q-me-2':isMobileView}" v-html="queryText"
       @click.prevent="handleSuggestionClick">
    </a>
  </li>
</template>

<script setup>
import { computed, defineProps, inject } from 'vue'
import { useUrlStore } from '@/store/SerpPage/UrlStore'
import { storeToRefs } from 'pinia/dist/pinia'
import { useMobileViewStore } from '@/store/MobileViewStore'

const SmartSearchConfig = inject('SmartSearchConfig').value

const props = defineProps(['suggestion'])

const queryText = computed(() => {
  return props.suggestion.highlight || props.suggestion.query
})

const urlStore = useUrlStore()
const mobileViewStore = useMobileViewStore()
const { isMobileView } = storeToRefs(mobileViewStore)

const handleSuggestionClick = () => {
  const query = (props.suggestion?.query || '').trim();
  if (!query) return;
  
  urlStore.goToSerpPage(
      SmartSearchConfig.appConfiguration.redirectionUrl,
      query
  );
};
</script>

<style>
a.single-suggestion__link {
  cursor: pointer;
  font-size: 0.75em;
}

a.single-suggestion__link em {
  font-weight: 700 !important;
  font-style: normal !important;
}

@media (max-width: 991.98px) {
  a.single-suggestion__link {
    text-wrap: nowrap;
    padding: 0.25em 0.5em;
    color: #fff !important;
  }
  a.single-suggestion__link:hover{
    color: #fff !important;
  }
}
</style>
